import React, { FC } from 'react';

interface IProps {
  getCellClassName: (value: string | string[], index: number) => string;
  values: string[] | string[][];
  title: string;
}

const SummaryTableRow: FC<IProps> = props => {
  const { title, values, getCellClassName: cellClassName } = props;

  return (
    <tr className="trow">
      <td className="text">
        <div className="value">{title}</div>
      </td>

      {(values as any[]).map((h, index) => (
        <td key={`gross-td-${h}-${index}`} className={cellClassName(h, index)}>
          <div>
            <div>
              <div className={'value'}>{(Array.isArray(h) ? h[0] : h) || '--'}</div>
            </div>
          </div>
        </td>
      ))}
    </tr>
  );
};

export default SummaryTableRow;
